import React, { useId } from 'react';
import { Picker } from '../ui';
import './CoachPicker.css';

export const fullName = (u) => `${u.firstName} ${u.lastName}`;
// "Ann Smith and Bob Jones", "Ann Smith, Bob Jones (left) and Cat Lee"
export const coachNames = (list) => {
  const names = list.map(u => (u.left ? `${fullName(u)} (left)` : fullName(u)));
  return names.length < 2 ? names.join('') : `${names.slice(0, -1).join(', ')} and ${names[names.length - 1]}`;
};

// Pick none, one or several of the club's coaches and admins. value: ids.
// known: the people on the list being changed, so anyone on it who is no
// longer staff still shows, marked (left), and can be taken off.
export default function CoachPicker({ staff, value, onChange, known = [], label = 'Coaches' }) {
  const id = useId();
  const staffIds = new Set(staff.map(u => u.id));
  const options = [...staff, ...known.filter(u => !staffIds.has(u.id)).map(u => ({ ...u, left: true }))];
  const items = options.map(u => ({
    id: u.id,
    label: u.left ? `${fullName(u)} (left)` : fullName(u),
    search: u.email || '',
  }));
  return (
    <div className="coach-picker">
      <label className="bk-label" htmlFor={id}>{label}</label>
      {options.length === 0 ? (
        <p className="coach-picker__empty">No coaches or admins yet.</p>
      ) : (
        <Picker id={id} label={label} items={items} value={value} onChange={onChange} multiple placeholder="Search coaches…" noneText="No coach matches. Try a surname." />
      )}
    </div>
  );
}
